// extracted by mini-css-extract-plugin
export var cardHeader = "_ex-0";
export var reorderHandle = "_ex-3";
export var titleArea = "_ex-1";
export var titleAreaWithHandle = "_ex-2";